import React, { FC } from 'react'
import styles from './MapTools.module.scss'
import { Stack } from 'components/Stack'
import { SearchTool } from './components/SearchTool'
import { DrawingTools } from './components/DrawingTools'
import { TrafficTool } from './components/TrafficTool'
import { MobilityReportTool } from './components/MobilityReportTool'
import { CustomReportTool } from './components/CustomReportTool'
import { KeywordsReportTool } from './components/KeywordsReportTool'
import { AreaTools } from 'models/editor'
import { Icon } from 'components/Icon'
import { useTranslation } from 'react-i18next'
import { useUserContext } from 'context/user-context'
import { useMapEditorContext } from 'context/map-editor-context'
import { UserRoles } from 'models/user'
//import { useFetchProject } from 'services/project'
import { PredictiveReportTool } from './components/PredictiveReportTool'
import { Tooltip } from 'components/Tooltip'
import { useFetchOrganization } from 'services/organization'
//import { useEffect } from 'react'

type mapToolsProps = {
  onPinPointClick: () => any
  isPinpointActive: boolean | undefined
  flagRType: boolean
}

export const MapTools: FC<mapToolsProps> = ({ onPinPointClick, isPinpointActive, flagRType }) => {
  const { t } = useTranslation()
  //const { projectId } = useParams()
  const { organization } = useFetchOrganization()
  //const { project } = useFetchProject(projectId)
  const [{ areaTool: selectedTool }, mapEditorDispatch] = useMapEditorContext()
  const [currentUser] = useUserContext()
  let userHasRights = !currentUser!.isRole(UserRoles.STAFF)
  var hasCustomReport = organization?.customReport
  const hasTrafficTool = organization?.trafficTool
  const hasMobilityReport = organization?.mobilityReport
  const hasPredictiveReport = organization?.predictiveReport
  var hasCustomMP = hasCustomReport

  var str = window.location.href
  var flagHarry = str.includes('projects')
  var flagMarco = str.includes('projects')
  var hasCustomReportH = false
  var hasCustomReportMarco = false

  /*var url3 = window.location.href
  var arr = url3.split("/")
  var projectid4 = arr[4]*/

  if (organization?.id === 17 && flagHarry === true) {
    hasCustomReport = false
    hasCustomReportH = true
  } else {
    if (organization?.id === 17) {
      hasCustomReport = false
    }
  }

  if ((organization?.id === 38 || organization?.id === 39) && flagMarco === true) {
    hasCustomReport = false
    hasCustomReportMarco = true
  } else {
    if (organization?.id === 38 || organization?.id === 39) {
      hasCustomReport = false
      hasCustomReportMarco = false
    }
  }

  function reportHarry() {
    var url3 = window.location.href
    var arr = url3.split('/')
    var projectid3 = arr[4]
    window.location.href = 'http://mapserver.descifra.global/v1/getCsvHarry/' + projectid3
  }

  function reporMarcoPolo() {
    var url3 = window.location.href
    var arr = url3.split('/')
    var projectid3 = arr[4]
    window.location.href = 'http://izzidescifra.mx/v1/getKmlMarcoPolo/' + projectid3
  }

  //HACER LLAMADO A LA API DE DATOS PARA OBTENER EL REPORT TYPE

  return (
    <Stack space="medium" style={{ position: 'absolute', top: 16, left: 16 }}>
      <Tooltip label={t(`tooltips.maptools.buscador`)} direction="LEFT_CENTER">
        <SearchTool />
      </Tooltip>

      <div className={styles.toolsGroup}>
        {userHasRights && flagRType && (
          <DrawingTools isPinpointActive={isPinpointActive} onPinPointClick={onPinPointClick} />
        )}
      </div>

      <div className={styles.toolsGroup}>
        {hasTrafficTool === true && <TrafficTool />}
        {userHasRights && hasMobilityReport! > 0 && <MobilityReportTool />}
        {userHasRights && hasPredictiveReport! > 0 && <PredictiveReportTool />}
        {userHasRights && hasCustomReport === true && <CustomReportTool />}
        {organization?.keywordsReport && <KeywordsReportTool />}
        {userHasRights && hasCustomMP === true && hasCustomReportMarco === true && (
          <CustomReportTool />
        )}
        {hasCustomReportH === true && (
          <button onClick={reportHarry}>
            <Tooltip label={t(`tooltips.maptools.custom_report`)} direction="LEFT_CENTER">
              <Icon name="file-download-fill" />
            </Tooltip>
          </button>
        )}
        {flagMarco === true && hasCustomReportMarco === true && hasCustomMP === true && (
          <button onClick={reporMarcoPolo}>
            <Tooltip label={t(`tooltips.maptools.custom_report`)} direction="LEFT_CENTER">
              <Icon name="file-download-fill" />
            </Tooltip>
          </button>
        )}
      </div>

      <div className={styles.toolsGroup}>
        <button
          onClick={() => {
            mapEditorDispatch.selectTool(AreaTools.MEASURE)
            mapEditorDispatch.setWizard(null)
          }}
          data-selected={selectedTool === AreaTools.MEASURE ? true : undefined}
          aria-label={t('map.tools.drawing.ruler')}
        >
          <Tooltip label={t(`tooltips.maptools.regla`)} direction="LEFT_CENTER">
            <Icon name="ruler-2-line" />
          </Tooltip>
        </button>
      </div>
    </Stack>
  )
}

MapTools.displayName = 'MapTools'
